export var SubscriptionTerms;
(function (SubscriptionTerms) {
    SubscriptionTerms["Monthly"] = "Monthly";
    SubscriptionTerms["OneYear"] = "1 Year";
    SubscriptionTerms["TwoYears"] = "2 Years";
    SubscriptionTerms["ThreeYears"] = "3 Years";
    SubscriptionTerms["FiveYears"] = "5 Years";
})(SubscriptionTerms || (SubscriptionTerms = {}));
